module.exports = __webpack_public_path__ + "media/images/enfoque-292c48b29f14063a70e2c099b93f53a9.png";